var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIosStatsWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 17.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.625 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.739,21.955H14.92a.365.365,0,0,0,.364-.364V4.864A.365.365,0,0,0,14.92,4.5H12.739a.365.365,0,0,0-.364.364V21.591A.365.365,0,0,0,12.739,21.955Z",
    transform: "translate(-2.386)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.989,27.523H8.17a.365.365,0,0,0,.364-.364V20.614a.365.365,0,0,0-.364-.364H5.989a.365.365,0,0,0-.364.364v6.545A.365.365,0,0,0,5.989,27.523Z",
    transform: "translate(0 -5.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.493,25.932h2.173a.367.367,0,0,0,.368-.368V16.118a.367.367,0,0,0-.368-.368H19.493a.367.367,0,0,0-.368.368v9.445A.367.367,0,0,0,19.493,25.932Z",
    transform: "translate(-4.773 -3.977)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.875,9.368V23.177a.367.367,0,0,0,.368.368h2.173a.367.367,0,0,0,.368-.368V9.368A.367.367,0,0,0,28.416,9H26.243A.367.367,0,0,0,25.875,9.368Z",
    transform: "translate(-7.159 -1.591)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIosStatsWhite);
export default __webpack_public_path__ + "static/media/iconIosStatsWhite.bfa87b60b9fe0cb0b1958a607e5f8f75.svg";
export { ForwardRef as ReactComponent };